<template>
  <div class="page">
    <div class="row">
      <div class="text-center col-12">
        <h4 class="m-3">Termo de Consentimento do Usuário</h4>
        <embed :src="this.urlTermo" style="height: 45vw; width: 75vw" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12" style="text-align: right">
        <b-button variant="danger" class="me-1">
          <i class="mdi mdi-cancel font-size-16 align-middle"></i>
          Recusar
        </b-button>

        <b-button variant="success" @click="aceitar()">
          <i class="mdi mdi-check font-size-16 align-middle"></i>
          Aceitar
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {},
      urlTermo: "",
    };
  },
  created() {
    this.user = this.$store.state.me;
    this.buscarTermo();
  },
  methods: {
    buscarTermo() {
      this.loading = true;
      this.$http
        .get("api/lgpd/buscarTermo/" + this.user.nr_docto, {
          responseType: "blob",
        })
        .then((response) => {
          var blob = new Blob([response.data], {
            type: "application/pdf",
          });
          this.urlTermo = window.URL.createObjectURL(blob);
        });
    },

    aceitar() {
      this.$http
        .post("api/lgpd/aprovaTermo", {
          SqTipoDocumentoJuridico: 4,
          Cpf: this.user.nr_docto,
          Consentiu: 1,
        })
        .then(() => {
          this.$store.commit("VALIDA_TERMO_LGPD", true);
          this.verificaDocumentoAssembleia();
        });
    },

    verificaDocumentoAssembleia() {
      this.$http
        .get("api/reuniao/verificarTermo")
        .then((response) => {
          if (!response.data.sq_upload) {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
            this.$router.push("/");
          } else {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", false);
            this.$router.push("/termo/assembleia/" + response.data.sq_upload);
          }
        })
        .catch(() => {
          this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
          this.$router.push("/");
        });
    },
  },
};
</script>